import { render, staticRenderFns } from "./tslogin.vue?vue&type=template&id=d65c3e1a&"
import script from "./tslogin.vue?vue&type=script&lang=js&"
export * from "./tslogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports